/* global ADV */

import React, { Component } from "react";
import PropTypes from "prop-types";

export const PAD_FOR_LEGEND = "pad-for-legend";
export const NO_CONTENT = "no-content";
export const HIGHLIGHT_SUBHEADER = "highlight-subheader";
export const CAROUSEL = "carousel";
export const NO_LINK = "no-link";
export const EDIT_LINK = "edit-link";
export const NO_CLICK = "no-click";

export default class Capsule extends Component {
  handleClick() {
    const { href, params, onClick, fpId, clientId } = this.props;

    if (!href) {
      return;
    }

    if (fpId) {
      ADV.consumer.setFPID(clientId, fpId);
    }

    if (!onClick) {
      ADV.util.Router.go2(href, params);
    } else {
      onClick.call();
    }
  }

  render() {
    const { header, subheader, hide, children, className, href } = this.props;

    const defaultClassName = `capsule mobile ${!href ? "no-link" : ""}`;

    return (
      <div>
        <div
          onClick={this.handleClick.bind(this)}
          className="mobile-consumer-heading-separator"
        >
          {header} {subheader}
        </div>

        <div
          className={`${defaultClassName} ${className || ""}`}
          style={{ display: hide ? "none" : "block" }}
        >
          {children}
        </div>
      </div>
    );
  }
}

Capsule.propTypes = {
  header: PropTypes.string.isRequired,
  subheader: PropTypes.node,
  children: PropTypes.elements,
  className: PropTypes.string,
  hide: PropTypes.bool,
  href(props, propName, componentName) {
    if (!ADV.routes.hasOwnProperty(props[propName])) {
      return new Error(
        `Invalid prop '${propName}' supplied to '${componentName}'. Value must exist in ADV.routes.`
      );
    }
  },
  params: PropTypes.object
};
